import { render, staticRenderFns } from "./knightdetails.vue?vue&type=template&id=5ec86982"
import script from "./knightdetails.vue?vue&type=script&lang=ts"
export * from "./knightdetails.vue?vue&type=script&lang=ts"
import style0 from "./knightdetails.vue?vue&type=style&index=0&id=5ec86982&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports